import React from 'react'
import { ReactComponent } from './pay.svg'
import { MergeReactElementProps } from '../types'

interface PayProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', PayProps>

export const Pay = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
